import $ from 'jquery';
import Inn from 'blocks/inn/inn';
import City from 'blocks/city/city';
import Select from 'blocks/select/select';
// import Numbered from 'input.numbered';
import 'jquery.inputmask/dist/jquery.inputmask.bundle';
import 'bootstrap-datepicker';



export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaConnectInfo',
			dom: {
				inn: '.js-inn',
				city: '.js-city',
				date: '#yotaConnectInfoInnDate',
				form: '#yotaConnectInfoForm',
				entityType: '#yotaConnectInfoFieldEntityTypeSelect',
				documentType: '#yotaConnectInfoFieldDocumentTypeSelect',
				directorOffice: '#yotaConnectInfoFieldDirectorOfficeSelect',
				directorPowers: '#yotaConnectInfoFieldDirectorPowersSelect',
				contractCity: '#yotaConnectInfoFieldContractCitySelect',
				field: {
					entity: {
						type: '#yotaConnectInfoFieldEntityType',
						name: '#yotaConnectInfoFieldEntityName',
						inn: '#yotaConnectInfoFieldEntityInn',
						kpp: '#yotaConnectInfoFieldEntityKpp',
						ogrn: '#yotaConnectInfoFieldEntityOgrn',
						ogrnip: '#yotaConnectInfoFieldEntityOgrnip',
						date: '#yotaConnectInfoFieldEntityDate',
						address: '#yotaConnectInfoFieldEntityAddress'
					},
					document: {
						type: '#yotaConnectInfoFieldDocumentType',
						birthdate: '#yotaConnectInfoFieldDocumentBirthdate',
						number: '#yotaConnectInfoFieldDocumentNumber',
						date: '#yotaConnectInfoFieldDocumentDate',
						issued: '#yotaConnectInfoFieldDocumentIssued',
						issuedCode: '#yotaConnectInfoFieldDocumentIssuedCode'
					},
					director: {
						fio: '#yotaConnectInfoFieldDirectorFio',
						office: '#yotaConnectInfoFieldDirectorOffice',
						custom: '#yotaConnectInfoFieldDirectorOfficeCustom',
						powers: '#yotaConnectInfoFieldDirectorPowers',
						powersCustom: '#yotaConnectInfoFieldDirectorPowersCustom'
					},
					contract: {
						date: '#yotaConnectInfoFieldContractDate',
						city: '#yotaConnectInfoFieldContractCity',
						cityId: '#yotaConnectInfoFieldContractCityId'
					},
					user: {
						login: '#yotaConnectInfoFieldUserLogin'
					},
					package: {
						packageType: '#infoPackageType'
					}
				},
				error: '.js-connect-info-error'
			},
			classes: {
				type: {
					ooo: 'b-connect-info_type_ooo',
					ip: 'b-connect-info_type_ip'
				},
				director: {
					custom: 'b-connect-info_director_custom',
					powersCustom: 'b-connect-info_director_powers-custom'
				},
				inn: {
					find: 'b-connect-info_inn_find'
				},
				login: {
					valid: 'b-connect-info_login_valid'
				},
				error: {
					active: 'b-connect-info__error_state_active'
				},
				field: {
					error: 'b-field_state_error'
				}
			},
			types: [],
			data: {
				inn: '',
				date: '',
				entity: {
					type: '',
					name: '',
					inn: '',
					kpp: '',
					ogrn: '',
					ogrnip: '',
					date: '',
					address: ''
				},
				document: {
					type: '',
					birthdate: '',
					number: '',
					date: '',
					issued: '',
					issuedCode: ''
				},
				director: {
					fio: '',
					office: '',
					custom: '',
					powers: '',
					powersCustom: ''
				},
				contract: {
					date: '',
					city: ''
				},
				user: {
					login: '',
					valid: false
				},
				package: {
					packageType: ''
				},
				error: {}
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.data = this.options.data;
		this.masks = this.options.masks;
		this.iptypes = [];
		this.init = true;
		this.viewForm = false;

		/* eslint quote-props: 0 */
		this.maskConfig = {
			placeholder: ' ',
			definitions: {
				'Б': {
					validator: '[А-я]',
					cardinality: 1,
					casing: 'upper'
				},
				'S': {
					validator: '[A-zА-я0-9]',
					cardinality: 1,
					casing: 'upper'
				}
			}
		};
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$window = $(window);
		return this;
	}

	getDom() {
		this.$inn = this.$el.find(this.options.dom.inn);
		this.$date = this.$el.find(this.options.dom.date);
		this.$form = this.$el.find(this.options.dom.form);

		this.$city = this.$el.find(this.options.dom.city);
		this.$entityType = this.$el.find(this.options.dom.entityType);
		this.$documentType = this.$el.find(this.options.dom.documentType);
		this.$directorOffice = this.$el.find(this.options.dom.directorOffice);
		this.$directorPowers = this.$el.find(this.options.dom.directorPowers);
		this.$contractCity = this.$el.find(this.options.dom.contractCity);

		this.field = {
			entity: {
				$type: this.$el.find(this.options.dom.field.entity.type),
				$name: this.$el.find(this.options.dom.field.entity.name),
				$inn: this.$el.find(this.options.dom.field.entity.inn),
				$kpp: this.$el.find(this.options.dom.field.entity.kpp),
				$ogrn: this.$el.find(this.options.dom.field.entity.ogrn),
				$ogrnip: this.$el.find(this.options.dom.field.entity.ogrnip),
				$date: this.$el.find(this.options.dom.field.entity.date),
				$address: this.$el.find(this.options.dom.field.entity.address)
			},
			document: {
				$type: this.$el.find(this.options.dom.field.document.type),
				$birthdate: this.$el.find(this.options.dom.field.document.birthdate),
				$number: this.$el.find(this.options.dom.field.document.number),
				$date: this.$el.find(this.options.dom.field.document.date),
				$issued: this.$el.find(this.options.dom.field.document.issued),
				$issuedCode: this.$el.find(this.options.dom.field.document.issuedCode)
			},
			director: {
				$fio: this.$el.find(this.options.dom.field.director.fio),
				$office: this.$el.find(this.options.dom.field.director.office),
				$custom: this.$el.find(this.options.dom.field.director.custom),
				$powers: this.$el.find(this.options.dom.field.director.powers),
				$powersCustom: this.$el.find(this.options.dom.field.director.powersCustom)
			},
			contract: {
				$date: this.$el.find(this.options.dom.field.contract.date),
				$city: this.$el.find(this.options.dom.field.contract.city),
				$cityId: this.$el.find(this.options.dom.field.contract.cityId)
			},
			user: {
				$login: this.$el.find(this.options.dom.field.user.login)
			},
			package: {
				$packageType: this.$el.find(this.options.dom.field.package.packageType)
			}
		};
		this.$error = this.$el.find(this.options.dom.error);


		this.$fields = false;
		const self = this;
		$.each(self.field, function (groupKey, group) {
			$.each(group, function (fieldKey, $field) {
				if (self.$fields !== false) {
					self.$fields = self.$fields.add($field);
				} else {
					self.$fields = $field;
				}
				$field
					.data('group', groupKey)
					.data('field', fieldKey.slice(1));
			});
		});
		return self;
	}

	getIpTypes() {
		const self = this;
		$.each(self.options.types, function (key, type) {
			if (type.ip === true) {
				self.iptypes.push(type.value);
			}

		});
		return self;
	}

	isIp(value) {
		return (this.iptypes).indexOf(value) >= 0;
	}

	get() {
		const data = this.$form.serializeArray();
		const json = {};
		$.each(data, function (key, val) {
			if (
				val.name != 'city-search' &&
				val.name != 'query' &&
				val.name != 'city' &&
				val.name != 'type'
			) {
				json[val.name] = val.value;
			}
		});
		json[this.field.user.$login.attr('name')] = this.field.user.$login.val();
		return JSON.stringify(json);
	}

	update(data) {
		if (typeof data !== 'undefined') {
			this.data = $.extend(false, {}, this.data, data);
		}
		if (this.data.inn != '') {
			this.viewForm = true;
		}

		this.inn.setValue(this.data.inn);
		this.$date.text(this.data.date);
		this.$el.toggleClass(this.options.classes.type.ip, this.data.date !== '');

		this.entityType.setValue(this.data.entity.type);
		this.field.entity.$type.val(this.data.entity.type);
		this.field.entity.$name.val(this.data.entity.name);
		this.field.entity.$inn.val(this.data.entity.inn);
		this.field.entity.$kpp.val(this.data.entity.kpp);
		this.field.entity.$ogrn.val(this.data.entity.ogrn);
		this.field.entity.$ogrnip.val(this.data.entity.ogrnip);
		this.field.entity.$date.val(this.data.entity.date).trigger('keyup');
		this.field.entity.$address.val(this.data.entity.address);


		const oldType = this.field.document.$type.val();

		this.field.document.$type.val(this.data.document.type);
		this.documentType.setValue(this.data.document.type);

		if ((oldType !== this.data.document.type || this.init) && this.data.document.type != '') {
			this.field.document.$number.data('type', this.data.document.type);
			this.init = false;
			this.field.document.$number.inputmask(this.masks[this.data.document.type], this.maskConfig);
		}

		this.field.document.$number.val(this.data.document.number);
		this.field.document.$birthdate.val(this.data.document.birthdate).trigger('keyup');
		this.field.document.$date.val(this.data.document.date).trigger('keyup');
		this.field.document.$issued.val(this.data.document.issued);
		this.field.document.$issuedCode.val(this.data.document.issuedCode);

		this.field.director.$fio.val(this.data.director.fio);
		this.directorOffice.setValue(this.data.director.office);
		this.field.director.$office.val(this.data.director.office);
		this.field.director.$custom.val(this.data.director.custom);
		this.directorPowers.setValue(this.data.director.powers);
		this.field.director.$powers.val(this.data.director.powers);
		this.field.director.$powersCustom.val(this.data.director.powersCustom);

		this.field.contract.$date.val(this.data.contract.date).trigger('keyup');


		if (this.data.contract.cityId) {
			this.field.contract.$cityId.val(this.data.contract.cityId);
			if (this.data.contract.cityId != '' && this.data.contract.city === true) {
				this.data.contract.city = this.getCityNameFromId(this.data.contract.cityId);
			}
			this.field.contract.$city.val(this.data.contract.city);

			this.city.set(this.data.contract.cityId, this.data.contract.city);
		}


		this.field.user.$login.val(this.data.user.login);
		this.field.package.$packageType.val(this.data.package.packageType);

		this.$el.toggleClass(this.options.classes.login.valid, this.data.user.valid);
		this.$el.toggleClass(this.options.classes.inn.find, this.data.date != '' && typeof this.data.date != 'undefined');

		this.states();
		return this;
	}

	setPackageType(type) {
		this.field.package.$packageType.val(type);
	}

	onDocumentTypeChange() {
		const type = this.field.document.$type.val();
		const oldType = this.field.document.$number.data('lasttype');
		if (type !== oldType) {
			this.field.document.$number.data('type', type);
			this.field.document.$number.inputmask(this.masks[type], this.maskConfig);
			this.field.document.$number.val('');
		}
	}

	onInnFind(event, data, type) {
		this.viewForm = true;
		if (type) {
			const setType = this.iptypes[0];
			this.update({entity: {type: setType}});
			this.$el.removeClass(this.options.classes.inn.find);
		} else {
			this.update(data);
		}
	}

	onChange(event) {
		const $field = $(event.currentTarget);
		const {group, field} = $field.data();

		this.data[group][field] = $field.val();

		this.states();
		return this;
	}

	onFocus(event) {
		const $field = $(event.currentTarget);
		delete this.data.error[$field.attr('name')];
		this.states();
		return this;
	}

	states() {
		const self = this;
		const entityType = self.field.entity.$type.val();
		const entityTypeIsIp = self.isIp(entityType) && self.viewForm;
		const entityTypeIsOoo = !self.isIp(entityType) && self.viewForm;
		const directorOffice = self.field.director.$office.val();
		const directorPowers = self.field.director.$powers.val();

		self.$el
			.toggleClass(self.options.classes.type.ip, entityTypeIsIp)
			.toggleClass(self.options.classes.type.ooo, entityTypeIsOoo)
			.toggleClass(self.options.classes.director.custom, entityTypeIsOoo && directorOffice === 'custom')
			.toggleClass(self.options.classes.director.powersCustom, entityTypeIsOoo && directorPowers === 'custom');

		if (Object.keys(self.data.error).length) {
			self.$error.each(function () {
				const $error = $(this);
				const name = $error.data('name');
				let find = false;
				$.each(self.data.error, function (key, error) {
					if (name == key) {
						$error.html(error);
						find = true;
					}
				});
				$error.toggleClass(self.options.classes.error.active, find);
				self.$fields.filter('[name="' + name + '"]').parent().toggleClass(self.options.classes.field.error, find);

			});
		} else {
			self.$error
				.removeClass(self.options.classes.error.active)
				.html('');
			self.$fields.parent().removeClass(self.options.classes.field.error);
		}

		self.onEntityInnInput();
		return self;
	}

	onDirectorCustomInput(event) {
		const $target = $(event.currentTarget);
		const value = $target.val();
		if (value.length > 15) {
			$target[0].value = value.substr(0, 15);
		}
	}

	onDirectorPowersCustomInput(event) {
		const $target = $(event.currentTarget);
		const value = $target.val();
		if (value.length > 50) {
			$target[0].value = value.substr(0, 50);
		}
	}

	onEntityInnInput() {
		const $target = this.field.entity.$inn;
		const entityType = this.field.entity.$type.val();
		const entityTypeIsIp = this.isIp(entityType) && this.viewForm;

		const value = $target.val();
		let correct = value;
		correct = correct.replace(/[^0-9]/gim, '');
		let max = 10;
		if (entityTypeIsIp) {
			max = 12;
		}
		if (correct.length > max) {
			correct = correct.substr(0, max);
		}
		if (correct != value) {
			$target[0].value = correct;
		}
	}

	onEntityKppInput() {
		const $target = this.field.entity.$kpp;
		const value = $target.val();
		let correct = value;
		correct = correct.replace(/[^0-9]/gim, '');
		if (correct.length > 9) {
			correct = correct.substr(0, 9);
		}
		if (correct != value) {
			$target[0].value = correct;
		}
	}

	onEntityOgrnInput() {
		const $target = this.field.entity.$ogrn;
		const value = $target.val();
		let correct = value;
		correct = correct.replace(/[^0-9]/gim, '');
		if (correct.length > 13) {
			correct = correct.substr(0, 13);
		}
		if (correct != value) {
			$target[0].value = correct;
		}
	}

	onEntityOgrnipInput() {
		const $target = this.field.entity.$ogrnip;
		const value = $target.val();
		let correct = value;
		correct = correct.replace(/[^0-9]/gim, '');
		if (correct.length > 15) {
			correct = correct.substr(0, 15);
		}
		if (correct != value) {
			$target[0].value = correct;
		}
	}

	onCityChange(data) {
		if (data) {
			this.field.contract.$city.val(data.name);
			this.field.contract.$cityId.val(data.id);

		} else {
			this.field.contract.$city.val('');
			this.field.contract.$cityId.val('');
		}
	}

	getCityNameFromId(id) {
		let cityName = '';
		const cityId = id;
		if (yotaPortlets.city) {
			$.each(yotaPortlets.city.main, function (key, city) {
				if (cityId == city.id) {
					cityName = city.name;
				}
			});
			if (cityName == '') {
				$.each(yotaPortlets.city.all, function (key, city) {
					if (cityId == city.id) {
						cityName = city.name;
					}
				});
			}
		}
		return cityName;
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.getIpTypes();

			this.entityType = new Select({el: this.$entityType}).render();

			this.entityType.setOptions(this.options.types);

			this.documentType = new Select({el: this.$documentType}).render();
			this.directorOffice = new Select({el: this.$directorOffice}).render();
			this.directorPowers = new Select({el: this.$directorPowers}).render();
			// this.contractCity = new Select({el: this.$contractCity}).render();

			// this.contractCity.setOptions(this.options.cities);

			this.inn = new Inn({el: this.$inn}).render();
			this.city = new City({
				el: this.$city,
				callback: {
					set: this.onCityChange.bind(this)
				}
			}).render();


			this.$documentType.on('change', this.onDocumentTypeChange.bind(this));

			// this.field.entity.$type.on('change', this.onSelectChange.bind(this));
			// this.field.director.$office.on('change', this.onSelectChange.bind(this));

			$.fn.datepicker.dates['ru'] = {
				days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
				daysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
				daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
				months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
				monthsShort: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
				today: 'Сегодня',
				clear: 'Очистить',
				format: 'mm/dd/yyyy',
				titleFormat: 'MM yyyy',
				weekStart: 1
			};
			this.field.entity.$date.datepicker({
				format: 'dd.mm.yyyy',
				language: 'ru',
				templates: {
					leftArrow: '&lt;',
					rightArrow: '&gt;'
				},
				autoclose: true,
				endDate: '0d'
			});

			this.field.document.$birthdate.datepicker({
				format: 'dd.mm.yyyy',
				language: 'ru',
				templates: {
					leftArrow: '&lt;',
					rightArrow: '&gt;'
				},
				autoclose: true,
				endDate: '0d'
			});

			this.field.document.$date.datepicker({
				format: 'dd.mm.yyyy',
				language: 'ru',
				templates: {
					leftArrow: '&lt;',
					rightArrow: '&gt;'
				},
				autoclose: true,
				endDate: '0d'
			});
			this.field.contract.$date.datepicker({
				format: 'dd.mm.yyyy',
				language: 'ru',
				templates: {
					leftArrow: '&lt;',
					rightArrow: '&gt;'
				},
				autoclose: true,
				startDate: '0d'
			});


			this.field.director.$custom.on('input change paste keydown', this.onDirectorCustomInput.bind(this));
			this.field.director.$powersCustom.on('input change paste keydown', this.onDirectorPowersCustomInput.bind(this));

			this.field.entity.$inn.on('input change paste keydown', this.onEntityInnInput.bind(this));
			this.field.entity.$kpp.on('input change paste keydown', this.onEntityKppInput.bind(this));
			this.field.entity.$ogrn.on('input change paste keydown', this.onEntityOgrnInput.bind(this));
			this.field.entity.$ogrnip.on('input change paste keydown', this.onEntityOgrnipInput.bind(this));

			this.field.document.$issuedCode.inputmask('999-999', this.maskConfig);

			// this.masked = new InputMask('AA 9{6,7}');

			// this.masked(this.field.document.$number);

			// this.documentNumber = new Numbered(this.field.document.$number, {mask: 'ББ #{6,7}'});

			// this.entityDate = new Numbered(this.field.entity.$date, {mask: '##.##.####'});
			// this.documentDate = new Numbered(this.field.document.$date, {mask: '##.##.####'});
			// this.contractDate = new Numbered(this.field.contract.$date, {mask: '##.##.####'});

			// this.field.entity.$date.on('change', this.onSelectChange.bind(this));

			this.$window.on('yota.connect.info.inn', this.onInnFind.bind(this));

			this.$fields
				.on('focusin', this.onFocus.bind(this))
				.on('change', this.onChange.bind(this));

			this.update();
		}


		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/connect/info/info.js